import { mdiCalendarText } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment-timezone";
import React, { useMemo, useRef, useState } from "react";
import FlexPanel from "src/components/FlexPanel";
import PlayerImage from "src/components/Player/PlayerImage";
import TeamLogo from "src/components/Team/TeamLogo";
import styles from "./styles.scss";

// NOTE this basically copies a lot from player props, but hopefully in the future
// there can be one big section for players for better UX and cleaner code.

type PitcherProps = {
  pitcher: any;
};

const Pitcher = ({ pitcher: player }: PitcherProps) => {
  const [newsOpen, setNewsOpen] = useState(false);
  const newsRef = useRef<any>();

  // If you want to test injury or news, uncomment this
  // player.injuryStatus = "XXX";
  // player.news = {
  //   newsTime: moment(),
  //   analysis: "This is the analysis",
  // };

  const showLiveNewsDot = useMemo(() => {
    return moment(player.news?.newsTime ?? undefined).isAfter(moment().subtract(24, "hours"));
  }, [player.news?.newsTime]);

  return (
    <div className="pitcher-item">
      <PlayerImage url={player.imageUrl} containerClassName="player-image d-none d-sm-block" />
      <div className="pitcher-item-body">
        <div className="pitcher-item-titlebar">
          <PlayerImage url={player.imageUrl} containerClassName="player-image d-sm-none" />
          <div className="pitcher-item-titlebar-right">
            <div className="player-name">{player.fullName}</div>
            {Boolean(player.injuryStatus) && <div className="player-injury-status">{player.injuryStatus}</div>}
            {Boolean(player.news?.analysis) && (
              <div className="player-news-toggle" onClick={() => setNewsOpen(!newsOpen)}>
                <Icon path={mdiCalendarText} size="16px" color="#004198" />
                Latest News
                {showLiveNewsDot && <div className="player-news-live-dot" />}
              </div>
            )}
          </div>
        </div>
        <div className="section-divider" />
        {Boolean(player.news?.analysis) && (
          <React.Fragment>
            <div
              className="player-news"
              style={{
                height: newsOpen ? newsRef.current?.scrollHeight ?? 0 : 0,
                overflow: "hidden",
                transition: "all .3s",
              }}
              ref={newsRef}
            >
              <div className="player-news-date">Updated {moment(player.news.newsTime).calendar()}</div>
              <div className="player-news-analysis">{player.news.analysis}</div>
              <div className="section-divider" />
            </div>
          </React.Fragment>
        )}
        <div className="pitcher-section">
          <div className="pitcher-stat">
            <strong>Record</strong>
            <span>
              {player.wins ?? 0} - {player.losses ?? 0}
            </span>
          </div>
          <div className="pitcher-stat">
            <strong>ERA</strong>
            <span>{player?.earnedRunAvg?.toFixed(2) ?? "--"}</span>
          </div>
          <div className="pitcher-stat">
            <strong>Avg. IP</strong>
            <span>{player?.avgInnPitched?.toFixed(1) ?? "--"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

type TeamPitchersProps = {
  event: any;
  team: any;
};

const TeamPitchers = ({ event, team: _team }: TeamPitchersProps) => {
  const team = event[`${_team}Team`];
  const pitcher = event[`${_team}TeamPitcher`];

  return (
    <div className="team-starting-pitchers">
      <div className="team-starting-pitchers-head">
        <div className="team-image">
          <TeamLogo
            containerStyle={{ display: "flex", alignItems: "center" }}
            leagueName={event.league.name}
            teamAbbreviation={team.preferredAbbreviation}
            size={44}
          />
        </div>
        <div className="team-starting-pitchers-head-right">
          <div className="team-name">{team.lastName} Pitching</div>
        </div>
      </div>
      {pitcher ? (
        <Pitcher pitcher={pitcher} />
      ) : (
        <div className="no-pitchers">
          <span>Pitchers not yet announced, please check back later.</span>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

const MatchupTeamsStartingPitchers = ({ event }: { event: any }) => {
  return (
    <FlexPanel>
      <TeamPitchers event={event} team="away" />
      <TeamPitchers event={event} team="home" />
    </FlexPanel>
  );
};

export default MatchupTeamsStartingPitchers;
